import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { MatButton } from '@angular/material/button';
import { NumberInput, coerceNumberProperty } from '@angular/cdk/coercion';

export enum ModalWindowSize {
    fullScreen = 0,
    medium = 1,
    small = 2,
    seMessageBox = 3
}

export enum ButtonClick {
    ok = 1,
    cancel = 2,
    yes = 3,
    no = 4,
    externalCancel = 5,
    close = 6,
}

@Component({
    selector: 'se-modalwindow',
    templateUrl: './se-modalwindow.component.html',
    styleUrls: ['./se-modalwindow.component.scss'],
    animations: [
        trigger('window', [
            transition('void => *', [style({ transform: 'scale3d(.3, .3, .3)' }), animate(100)]),
            transition('* => void', [animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))]),
        ]),
    ],
})
export class SeModalWindowComponent {
    // MB: E' usata come classe base, quindi non deve comparire esternamente al modulo
    // data members

    @Input()
    alwaysPresent = false; // Usa "hidden" invece di "ngIf" per nascondere la modale.

    @Input()
    closable = true; // MB 21/01/2019: le mat-dialog di default chiudono

    @Input()
    closeOnHeader = false;

    private _visible: boolean;
    get visible() {
        return this._visible;
    }
    @Input()
    set visible(visible) {
        this.onVisible(visible);
    }

    @Input()
    transparent = false;

    @Input()
    windowSize: ModalWindowSize = ModalWindowSize.medium;

    @Input()
    fixedWidthPx?: number;

    _zIndex = 99999;
    @Input()
    set zIndex(zIndex: NumberInput) {
        this._zIndex = coerceNumberProperty(zIndex);
    }
    get zIndex() {
        return this._zIndex;
    }

    // events

    @Output()
    visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    buttonClick: EventEmitter<ButtonClick> = new EventEmitter<ButtonClick>();

    @ViewChild('btnOk')
    btnOk: MatButton;

    @ViewChild('btnYes')
    btnYes: MatButton;

    @ViewChild('window')
    window: ElementRef;

    containerDiv;

    // public functions
    onWindowClick(e: MouseEvent) {
        if (this.closable) {
            if (this.window && this.window.nativeElement) {
                const refElem = this.window.nativeElement;
                if (!!refElem) {
                    const containerDiv = refElem.querySelector('div.dialog-container');
                    if (!!containerDiv && !containerDiv.contains(e.target)) this.onBtnClick(ButtonClick.externalCancel);
                }
            }
        }
    }

    onClose() {
        this.visible = false;
    }

    // protected functions

    protected onBtnClick = (btn: ButtonClick) => {
        this.buttonClick.emit(btn);
        this.visible = false;
    };

    protected onVisible(visible: boolean) {
        this._visible = visible;
        this.visibleChange.emit(this.visible);

        this.setFocusOnYesOkButton();
    }

    protected setFocusOnYesOkButton = () => {
        // Gestione del fuoco sui pulsanti
        if (this.visible) {
            setTimeout(() => {
                if (this.btnOk) this.btnOk.focus();
                else if (this.btnYes) this.btnYes.focus();
            });
        }
    };
}
